<template>
  <div>
    <b-button
      pill
      variant="outline-info"
      id="id-location-request-btn"
      type="button"
      class="btn btn-rounded btn-light btn-block"
      :disabled="!generalConditionForCTA"
      @click.prevent="locationRequest()"
    >
      <b-icon-geo-alt />&nbsp;&nbsp;Request Location
    </b-button>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";

export default {
  props: {
    recipientId: String,
    conversationId: String,
    recipientLabel: String,
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("conversations", ["currentConversation"]),
    generalConditionForCTA() {
      const { status, operator_id } = this.currentConversation;
      const { enableConversationAssignment } = this.agencySettings;

      if (status === "active") {
        if (enableConversationAssignment === false) {
          return true;
        }
        if (
          enableConversationAssignment === true &&
          (
            operator_id === this.currentUser.user_id ||
            (
              operator_id !== null && this.$auth.can("admin:agency")
            )
          )
        ) {
          return true;
        }
      }
      return false;
    }
  },
  created() {
    EventBus.$on("video.request-location", async (data) => {
      const payload = {
        service_type: "addRecipientGeolocation",
        recipient_id: this.recipientId
      };
      const resp = await this.$ConveyApi.tokensApi.createMagicToken({ payload });
      EventBus.$emit("video.remote-control", {
        ...data,
        params: {
          token: resp.data.data.token,
          recipientId: this.recipientId,
        }
      });
    });
  },
  methods: {
    async locationRequest() {
      if (confirm("Send location request to this recipient?")) {
        try {
          const payload = {
            service_type: "addRecipientGeolocation",
            recipient_id: this.recipientId,
            send_invitation: true,
            invitation_message: this.currentAgency.settings.locationRequestExplainMsg,
            token_data: {
              agency_id: this.currentAgency.agency_id,
              conversation_id: this.conversationId,
              recipient: this.recipientLabel,
              recipient_id: this.recipientId,
              agency_logo: this.$cookie.get("x-agency-logo"),
            }
          };
          await this.$ConveyApi.tokensApi.createMagicToken({ payload });
          this.$toastr("success", "Location request sent");
        } catch (e) {
          this.$toastr("error", "Encountered an error sending location request. Please try again.");
          console.log(e.message);
        }
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("video.request-location");
  },
};
</script>
